import { createFileRoute } from '@tanstack/react-router'

import HighlightsUncategorizedContent from './-components/uncategorized'

export const Route = createFileRoute(
  '/_authenticated/$alias/settings/highlights/uncategorized',
)({
  component: HighlightsUncategorizedContent,
})
